// A helper function for passing down a ref created with createRef() to a component child
const setRef = (ref, value) => {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};

export default setRef;
